import React, { forwardRef, useCallback, useImperativeHandle } from 'react';
import type { MonitoringPopupPool } from './monitoringPopupHtml';
import { openMonitoringPopupAtPath } from './openPoolMonitoringWindow';
import { buildCctvCentralAllPopupPath } from './cctvPopupRoutes';

interface Pool extends MonitoringPopupPool {
  address?: string;
  capacity?: number;
  current_occupancy?: number;
}

interface Cctv {
  id: number;
  pool_id: number;
  name: string;
  location: string;
  url?: string;
  stream_url?: string;
  playback_url?: string;
  status: 'active' | 'inactive' | 'maintenance';
  camera_type: 'safety' | 'management' | 'other';
  purpose?: string;
}

interface AllPoolsMonitoringPopupProps {
  pools: Pool[];
  poolCctvs: { [key: string]: Cctv[] };
  poolsPerRow: number;
  useRemotePlayback: boolean;
  rotationIntervalSec: number;
  /** 개별 관제 필터 */
  adminIdFilter?: number | null;
}

export type AllPoolsMonitoringPopupHandle = {
  openAllPoolsInNewWindow: () => void;
};

const AllPoolsMonitoringPopup = forwardRef<AllPoolsMonitoringPopupHandle, AllPoolsMonitoringPopupProps>(
  function AllPoolsMonitoringPopup(
    { pools, poolsPerRow, rotationIntervalSec, adminIdFilter },
    ref
  ) {
    const openAllPoolsInNewWindow = useCallback(() => {
      if (pools.length === 0) {
        alert('표시할 시설 없음');
        return;
      }

      const poolIds = pools
        .map((p) => Number(p.id))
        .filter((id) => Number.isFinite(id) && id > 0);

      const popup = openMonitoringPopupAtPath(
        buildCctvCentralAllPopupPath({
          poolsPerRow,
          rotationIntervalSec,
          adminId: adminIdFilter,
          // 현재 화면에 보이는 시설만 (개별 관제 = 배당분)
          poolIds,
        })
      );
      if (!popup) {
        alert('팝업 창을 여기 불가. 브라우저 설정에서 팝업 허용을 확인.');
      }
    }, [pools, poolsPerRow, rotationIntervalSec, adminIdFilter]);

    useImperativeHandle(ref, () => ({ openAllPoolsInNewWindow }), [openAllPoolsInNewWindow]);

    return (
      <button type="button" onClick={openAllPoolsInNewWindow} style={{ display: 'none' }} aria-hidden tabIndex={-1}>
        전체 시설 모니터링
      </button>
    );
  }
);

export default AllPoolsMonitoringPopup;
